// extracted by mini-css-extract-plugin
module.exports = {"popoverTitle":"defaultBrandSettings_popoverTitle__1ohyg","modal":"defaultBrandSettings_modal__2-77G"};